import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EntitySchemaCatalogItem {
  id: string;
  name?: string;
  schemaPath?: string;
  [key: string]: unknown;
}

function normalizeCatalogResponse(value: unknown): EntitySchemaCatalogItem[] {
  // API の戻り値形式が確定していないため、配列 or ResultInfo{data} どちらでも吸収する
  const arr =
    Array.isArray(value) ? value : value && typeof value === 'object' && 'data' in value ? (value as any).data : null;
  if (!Array.isArray(arr)) return [];

  return arr.flatMap((row) => {
    if (!row || typeof row !== 'object') return [];
    const id = typeof (row as any).id === 'string' ? (row as any).id : '';
    if (!id) return [];
    const name = typeof (row as any).name === 'string' ? (row as any).name : undefined;
    const schemaPath =
      typeof (row as any).schemaPath === 'string'
        ? (row as any).schemaPath
        : `settings/test/entitySchema/${id}`;
    return [{ ...(row as any), id, name, schemaPath } satisfies EntitySchemaCatalogItem];
  });
}

@Injectable({ providedIn: 'root' })
export class CatalogService {
  private readonly http = inject(HttpClient);

  private readonly entitySchemaCatalog$ = this.fetchEntitySchemaCatalog().pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getEntitySchemaCatalog(): Observable<EntitySchemaCatalogItem[]> {
    return this.entitySchemaCatalog$;
  }

  private fetchEntitySchemaCatalog(): Observable<EntitySchemaCatalogItem[]> {
    const params = new HttpParams()
      .set('bucketCode', environment.bucketCodeMapping)
      .set('fileSystemId', 'settings/test/entitySchema/catalog');

    return this.http
      .get(`${environment.fileSystemApiUrl}/models`, { params })
      .pipe(map((res) => normalizeCatalogResponse(res)));
  }
}

